import styled from "styled-components";

const ParseLine = styled.hr`
  width: 100%;
  opacity: 0.2;
`;

export default ParseLine;
